import { useAssignLeadUserMutation } from '@common/cache';
import { formatApiError } from '@common/errors/error-formatting';
import { ITeamUser } from '@common/types';
import { t } from 'i18next';
import { useCallback, useState } from 'react';
import { toast } from 'react-toastify';

interface UseSidebarMemberProps {
  teamId: string;
  user: ITeamUser;
}

export const useSidebarMember = ({ teamId, user }: UseSidebarMemberProps) => {
  const { mutateAsync } = useAssignLeadUserMutation();
  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleOpen = useCallback(() => {
    setIsModalOpen(true);
  }, []);
  const handleClose = useCallback(() => {
    setIsModalOpen(false);
  }, []);
  const handleConfirm = useCallback(async () => {
    try {
      await mutateAsync({ team_id: teamId, user_id: user.id });
      setIsModalOpen(false);
      toast.success(t('adminPanel.teams.drawer.membersTab.setTeamLeadSuccess'));
    } catch (error) {
      toast.error(formatApiError(error));
    }
  }, [teamId, user.id, mutateAsync]);

  return {
    isModalOpen,
    handleOpen,
    handleClose,
    handleConfirm,
  };
};
